import pkdApi from 'store/api/pkd';
import { StudyArmRoles, StudyArms } from 'utils/enum';

const handleStudyArmConfig = (data) => {
  const {
    studyArmRoles,
    studyArmStatuses: studyArmStatusesData,
    studyArms,
  } = data;
  const studyArm = Object.values(studyArms).find(
    (studyArm) => studyArm.title === StudyArms.Research
  );
  const studyArmRole = Object.values(studyArmRoles).find(
    (studyArmRole) =>
      studyArmRole.studyArmId === studyArm.id &&
      studyArmRole.name === StudyArmRoles.Participant
  );
  const studyArmStatuses = Object.values(studyArmStatusesData).filter(
    (studyArmRole) => studyArmRole.studyArmId === studyArm.id
  );

  return {
    studyArm,
    studyArmRole,
    studyArmStatuses,
  };
};

const studyArmApi = pkdApi.injectEndpoints({
  endpoints : (build) => ({
    getSites : build.query({
      query : () => ({
        url     : '../v3/sites',
        method  : 'GET',
        headers : {
          'Content-Type' : 'application/vnd.api+json',
          Accept         : 'application/vnd.api+json',
        },
      }),
      providesTags      : ['Sites'],
      transformResponse : ({ data }) => data?.[0],
    }),
    getStudyArmConfig : build.query({
      query : () => ({
        url     : '../v3/app/conf/study-arm',
        method  : 'GET',
        headers : {
          'Content-Type' : 'application/vnd.api+json',
          Accept         : 'application/vnd.api+json',
        },
      }),
      providesTags      : ['StudyArmConfigs'],
      transformResponse : handleStudyArmConfig,
    }),
    getPersonStudyArm : build.query({
      query : ({ personId }) => ({
        url     : `../v3/people/${personId}/study-arms`,
        method  : 'GET',
        headers : {
          'Content-Type' : 'application/vnd.api+json',
          Accept         : 'application/vnd.api+json',
        },
      }),
      providesTags      : ['PersonStudyArm'],
      transformResponse : ({ data }) => data?.[0],
    }),
    createPersonStudyArm : build.mutation({
      query : ({ attributes, personId }) => ({
        url    : `../v3/people/${personId}/study-arms`,
        method : 'POST',
        body   : {
          data : {
            type : 'person-study-arm',
            attributes,
          },
        },
        headers : {
          'Content-Type' : 'application/vnd.api+json',
          Accept         : 'application/vnd.api+json',
        },
      }),
    }),
    updatePersonStudyArm : build.mutation({
      query : ({ attributes, personStudyArm }) => ({
        url    : `../v3/person-study-arms/${personStudyArm}`,
        method : 'PATCH',
        body   : {
          data : {
            type : 'person-study-arms',
            attributes,
            id   : personStudyArm,
          },
        },
        headers : {
          'Content-Type' : 'application/vnd.api+json',
          Accept         : 'application/vnd.api+json',
        },
      }),
    }),
    getPersonStudyArmAttributes : build.query({
      query : ({ personStudyArm }) => ({
        url     : `../v3/person-study-arms/${personStudyArm}/attributes`,
        method  : 'GET',
        headers : {
          'Content-Type' : 'application/vnd.api+json',
          Accept         : 'application/vnd.api+json',
        },
      }),
    }),
    createPersonStudyArmAttributes : build.mutation({
      query : ({ body, personStudyArm }) => ({
        url     : `../v3/person-study-arms/${personStudyArm}/attributes`,
        method  : 'POST',
        body,
        headers : {
          'Content-Type' : 'application/vnd.api+json',
          Accept         : 'application/vnd.api+json',
        },
      }),
    }),
  }),
  overrideExisting : false,
});

export const {
  useGetSitesQuery,
  useGetStudyArmConfigQuery,
  useGetPersonStudyArmQuery,
  useCreatePersonStudyArmMutation,
  useUpdatePersonStudyArmMutation,
  useGetPersonStudyArmAttributesQuery,
  useCreatePersonStudyArmAttributesMutation,
} = studyArmApi;
